import * as React from "react";
import logo from "../../../assets/img/logo-1.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styleForgetPassword from "./ForgetPassword.module.css";
import InputElement from "../../form/InputElement";
import { forgotPassowrdPhone } from "../../../adapters/apis/auth/auth";
import Footer from "../../../layouts/footer/Footer";
function ForgotPasswordOTPVerification() {
  const location = useLocation();
  const { mobile } = location.state || {};
  const navigate = useNavigate();
  // const [mobile, setMobile] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [errMessage, setErrMessage] = React.useState("");

  // function handleChange(parentCompenent, compenent, key, value) {
  //   setMobile(value);
  // }
  function forgetPassword() {
    setMessage("");
    setErrMessage("");
    forgotPassowrdPhone({ mobile: mobile })
      .then((res) => {
        setMessage(res?.data?.message ?? res?.data?.error);
      })
      .catch((error) => {
        setErrMessage(error?.response?.data?.message);
      });
  }
  return (
    <>
      <section className={styleForgetPassword["forget-password-section"]}>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-md-5">
              <div className={`card ${styleForgetPassword["card"]}`}>
                <div className="text-center">
                  <Link to="/">
                    <img src={logo} alt="Logo" />
                  </Link>
                  <div className="mt-5">
                    <ul class="nav  justify-content-center fs-6 border-0">
                      <li class="nav-item">
                        <Link
                          to="/forget-password-phone"
                          className={`${styleForgetPassword.bgCustom} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          رقم الهاتف المحمول
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link
                          to="/forget-password"
                          className={`${styleForgetPassword.bgGrey} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          البريد الإلكترونى
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {message && (
                  <div className="alert alert-primary" role="alert">
                    {message}
                  </div>
                )}
                <div
                  className={`${styleForgetPassword["card-body"]} card-body mt-5 mb-4`}
                >
                  <InputElement
                    placeholder=""
                    mb4="mb-4"
                    name="mobile"
                    labelHtmlFor="mobile"
                    labelClassName={` required ${styleForgetPassword["form-label"]} form-label`}
                    labelText="رقم الهاتف المحمول"
                    inputType="mobile"
                    inputClassName={`${styleForgetPassword["form-control"]} form-control`}
                    inputID="mobile"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={mobile}
                    // onChange={handleChange}
                    pText={errMessage}
                  />
                  <div
                    className={`${styleForgetPassword["login-btn"]} text-center my-5`}
                  >
                    <button
                      onClick={forgetPassword}
                      id="set_new_password_button"
                      className={`${styleForgetPassword["btn-login"]} mb-4 d-block`}
                    >
                      إرسال رمز التحقق
                    </button>
                    <button
                      onClick={() => navigate("/login")}
                      id="back_to_login_button"
                      className={`${styleForgetPassword["btn-bkToLogin"]} mb-4 d-block`}
                    >
                      العودة إلى شاشة تسجيل الدخول
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ForgotPasswordOTPVerification;
